import React from 'react';

import ModelLabels from 'model-hub/lib/ModelLabels';
import {
  formatModelCategoryLabel,
  getModelCapabilityLabels,
  type ScientificModelNode,
} from 'model-hub/scientific-models/ScientificModelMetadata';

interface ModelCapabilityLabelsProps {
  model: ScientificModelNode;
}

export default function ModelCapabilityLabels({model}: ModelCapabilityLabelsProps): JSX.Element {
  return (
    <ModelLabels
      capabilities={getModelCapabilityLabels(model)}
      category={formatModelCategoryLabel(model.category)}
    />
  );
}
